import React from "react";

import img1 from "../../../Assets/AboutUsImg/image.png";
import img2 from "../../../Assets/AboutUsImg/image-1.png";
import img3 from "../../../Assets/AboutUsImg/image-2.png";
import img4 from "../../../Assets/AboutUsImg/image-3.png";
import img5 from "../../../Assets/AboutUsImg/image-4.png";
import img6 from "../../../Assets/AboutUsImg/image-5.png";
import img7 from "../../../Assets/AboutUsImg/image-6.png";
import img8 from "../../../Assets/AboutUsImg/image-7.png";
import img9 from "../../../Assets/AboutUsImg/image-8.png";
import img10 from "../../../Assets/AboutUsImg/image-9.png";
import img11 from "../../../Assets/AboutUsImg/image-10.png";
import img12 from "../../../Assets/AboutUsImg/image-11.png";
import img13 from "../../../Assets/AboutUsImg/image-12.png";
import img14 from "../../../Assets/AboutUsImg/image-13.png";
import img15 from "../../../Assets/AboutUsImg/image-14.png";
import img16 from "../../../Assets/AboutUsImg/image-15.png";
import img17 from "../../../Assets/AboutUsImg/image-16.png";
import img18 from "../../../Assets/AboutUsImg/image-17.png";
import img19 from "../../../Assets/AboutUsImg/image-18.png";
import img20 from "../../../Assets/AboutUsImg/image-19.png";

const RecruitersPartners = () => {
  const companies = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img19,
    img20,
  ];

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white">
      <div className="pointer-events-none absolute top-0 -left-28 h-80 w-80 rounded-full bg-[#064585]/20 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 -right-32 h-96 w-96 rounded-full bg-[#5989C8]/25 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-10 md:py-12">
        {/* Header */}
        <div className="text-center mb-8" data-aos="fade-up">
          <p className="text-[10px] sm:text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#064585]">
            Trusted By
          </p>
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-900 mt-2">
            Our Trusted{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585]">
              Recruiters & Partners
            </span>
          </h1>
        </div>

        {/* Logos Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 place-items-center">
          {companies.map((logo, index) => (
            <div
              key={index}
              className="group bg-white/80 backdrop-blur-lg border border-[#5989C8]/10 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 p-2 flex items-center justify-center w-full h-32 cursor-pointer"
              data-aos="zoom-in"
            >
              <img
                src={logo}
                alt={`Recruiter ${index + 1}`}
                className="h-full object-contain opacity-80 group-hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecruitersPartners;
